import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import { Link } from 'react-router-dom';
import Icon from '../components/common/Icon';

const themes = [
  { 
    id: 'lavoro',
    title: 'Lavoro e Dignità', 
    excerpt: 'Salario minimo, stop al precariato e sicurezza sul lavoro. Le nostre proposte per le nuove generazioni.',
    icon: 'Briefcase',
    color: 'var(--color-primary)',
    image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'ambiente',
    title: 'Ambiente e Clima', 
    excerpt: 'Transizione ecologica giusta, energie rinnovabili e protezione della biodiversità.',
    icon: 'Leaf',
    color: '#10b981',
    image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'diritti',
    title: 'Diritti Civili', 
    excerpt: 'Uguaglianza, ius soli, diritti LGBTQIA+ e libertà individuali. Nessuno deve restare indietro.',
    icon: 'Heart',
    color: '#ec4899',
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'scuola',
    title: 'Scuola e Università', 
    excerpt: 'Diritto allo studio, edilizia scolastica e una formazione che guardi al futuro.',
    icon: 'GraduationCap',
    color: '#f59e0b',
    image: 'https://images.unsplash.com/photo-1523050337458-5ebbb12b58ad?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'europa',
    title: 'Europa e Mondo', 
    excerpt: 'Un’Europa federale, sociale e protagonista della pace globale.',
    icon: 'Globe',
    color: '#3b82f6',
    image: 'https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?q=80&w=800&auto=format&fit=crop'
  },
  { 
    id: 'salute-mentale',
    title: 'Salute Mentale', 
    excerpt: 'Rompere il tabù: supporto psicologico accessibile e benessere nelle comunità.',
    icon: 'Smile',
    color: '#8b5cf6',
    image: 'https://images.unsplash.com/photo-1527137342181-19aab11a8ee1?q=80&w=800&auto=format&fit=crop'
  }
];

const TemiPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Tematiche' }];
  
  return (
    <Layout>
      <HeroPage 
        breadcrumbs={breadcrumbs} 
        overline="Le nostre battaglie" 
        title="Tematiche" 
        subtitle="Dalle politiche per il lavoro alla giustizia climatica: ecco i temi che guidano la nostra azione politica ogni giorno." 
      />
      
      <section className="section">
        <div className="container">
          <div className="grid grid-3 gap-8">
            {themes.map((theme, idx) => (
              <Link 
                to={`/tematica?id=${theme.id}`} 
                key={theme.id}
                className="card-premium reveal reveal--scale"
                style={{ 
                  textDecoration: 'none', 
                  color: 'inherit',
                  display: 'flex',
                  flexDirection: 'column',
                  background: '#fff',
                  borderRadius: 'var(--radius-2xl)',
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '--delay': `${idx * 0.1}s`
                }}
              >
                <div style={{ height: '200px', overflow: 'hidden' }}>
                  <img src={theme.image} alt={theme.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: 'var(--space-8)', flex: 1 }}>
                  <div style={{ 
                    width: '48px', 
                    height: '48px', 
                    borderRadius: 'var(--radius-lg)', 
                    background: `${theme.color}15`, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    color: theme.color,
                    marginBottom: 'var(--space-6)'
                  }}>
                    <Icon name={theme.icon} size={24} />
                  </div>
                  <h3 className="h3 mb-3">{theme.title}</h3>
                  <p className="text-body-sm text-secondary mb-6">{theme.excerpt}</p>
                  <span className="text-small font-bold text-primary flex items-center gap-2">
                    Scopri di più <Icon name="ArrowRight" size={16} />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TemiPage;
